<script>
  import { _ as t } from "svelte-i18n";

  import { Icon, Item } from "t2c-components";
  import Document from "../folder/Document.svelte";

  export let lawcaseId;
  export let folders;
  export let documents;

  const countUnreadDocuments = (documents) => {
    return documents.filter((document) => !document.hasRead).length;
  };
</script>

<div class="list">
  {#each folders as folder (folder.id)}
    <Item link={`/lawcase/${lawcaseId}/folder/${folder.id}`} text={folder.name}>
      <div slot="icon" style="padding-right: 12px;">
        <Icon inline={true} icon="folder" />
      </div>
      <div slot="stats" class:empty={folder.countDocuments == 0}>
        <div>
          {$t("content.numDocuments", { values: { n: folder.countDocuments } })}
        </div>
        <div
          class="stat"
          class:empty={countUnreadDocuments(folder.documents) === 0}
        >
          {$t("content.numUnreadDocuments", {
            values: { n: countUnreadDocuments(folder.documents) },
          })}
        </div>
      </div>
    </Item>
  {/each}
  {#each documents as caseDocument (caseDocument.id)}
    <Document document={caseDocument} {lawcaseId} />
  {/each}
</div>

<style>
  .list {
    max-width: 600px;
    margin: 48px 0;
  }

  .stat {
    font-weight: 700;
  }

  .empty {
    font-weight: 400;
    color: #999;
  }
</style>
